// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"251":"checkout","391":"info","582":"bundles","644":"account","884":"admin","983":"learn"}[chunkId] || chunkId) + "." + {"68":"cc74363e","251":"8aa97890","391":"542f47c9","582":"47a5e191","644":"bbba1a0e","884":"4393d900","983":"b343bdde"}[chunkId] + ".chunk.js";
};